// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-10KSb4Fj","publlictitle":"wmf-2pMcKbmO","required":"wmf-3JK7T8dv","informationtitle":"wmf-FEWFvjY1","titles":"wmf-1SZY9Xa8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnonhaitaodetails/medical-equipmentn-onhaitao.module.less
// module id = 441
// module chunks = 0